// Quais clientes o usuário já mandou parar de avisar sobre cadastro incompleto.
//
// Fica no navegador de propósito: é preferência de quem está usando, não dado do cadastro. Um
// escritório que acabou de migrar tem todos os clientes sem endereço, e um aviso que nunca desliga
// deixa de ser aviso — as pessoas aprendem a ignorar. Dispensar é a saída para quem já sabe.
//
// O aviso volta sozinho se o cadastro mudar e voltar a faltar algo? Não: a dispensa é por cliente e
// vale até ser limpa. Mas quando o cadastro é completado, não há mais o que avisar de qualquer forma.

const CHAVE = 'avisoCadastroIncompletoDispensado';

// Identifica o cliente pelo CPF/CNPJ (só dígitos e letras); sem documento, cai no nome
export const identificadorDe = (pessoa) => {
  const p = pessoa || {};
  const doc = (p.cpfCnpj || '').toString().replace(/[^0-9A-Za-z]/g, '').toUpperCase();
  return doc || (p.nome || '').toString().trim().toUpperCase();
};

const identificador = identificadorDe;

// O localStorage pode não estar disponível (aba anônima, cookies bloqueados): nesse caso o aviso
// simplesmente continua aparecendo, que é o comportamento seguro.
function lerLista() {
  try {
    const bruto = window.localStorage.getItem(CHAVE);
    const lista = bruto ? JSON.parse(bruto) : [];
    return Array.isArray(lista) ? lista : [];
  } catch (erro) {
    return [];
  }
}

// A lista inteira, para quem precisa guardá-la no estado da tela em vez de consultar a cada render
export function listaDispensados() {
  return lerLista();
}

export function estaDispensado(pessoa) {
  const id = identificador(pessoa);
  return !!id && lerLista().includes(id);
}

export function dispensar(pessoa) {
  const id = identificador(pessoa);
  if (!id) return;
  try {
    const lista = lerLista();
    if (!lista.includes(id)) window.localStorage.setItem(CHAVE, JSON.stringify([...lista, id]));
  } catch (erro) {
    // sem onde guardar: o aviso volta na próxima vez, e tudo bem
  }
}

export function limparDispensas() {
  try {
    window.localStorage.removeItem(CHAVE);
  } catch (erro) {
    // nada a fazer
  }
}
